import React, { useState, useEffect } from 'react';
import "./RegistrationForm.scss"
import { Link, useNavigate } from "react-router-dom";
import dataStore from '../../Store/store';
import Config from "../../core/constants/Config";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { submitReqistrationFormService } from '../../core/service/common.service';
import * as sessionStorage from "../../core/Security/session-storage";
import { DataConstant } from '../../core/constants/data.constant';
function RegistrationForm() {

  const [myProfileUpdate, setMyProfileUpdate] = useState({

    customerId: localStorage.getItem("custId")? localStorage.getItem("custId"): 0 || '',
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    birthday: "",
    referral: ""
    // Array to store image files
  });

  useEffect(() => {
    dataStore.setIsCheckout(false); // Set isCheckout to false when Layout component mounts
  }, []);
  const navigate = useNavigate();

  const handleFormSubmit = async (event) => {
    event.preventDefault();

   

    try {


      // const token = sessionStorage.getJwtToken(DataConstant.sessionStorage.JWT_TOKEN);

      // console.log("JWT",token);
     

      const response = await fetch(`${Config.local_public_endpoint}/submitReqistrationForm`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
       //   "Authorization": `Bearer ${token}`, // Set the Content-Type header
        },
        body: JSON.stringify(myProfileUpdate), // Convert the JavaScript object to JSON string
      });

      if (response.ok) {
        if (dataStore.isUserLogin) {
          
          navigate("/booking-tabs");  

        } else {
          navigate("/booking-tabs");  
        }
      }
      else {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      setMyProfileUpdate(data);
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMyProfileUpdate((prevData) => ({ ...prevData, [name]: value }));
  };


  return (
    <>
    <Navbar />
    <div className='registration-form'>
      
      <h2>CREATE ACCOUNT</h2>
      <div className='inside-reg-form'>
        <form onSubmit={handleFormSubmit}>
          <div>
            <div className='reg-text'>
              <label htmlFor="firstName">First Name</label>
            </div>
            <div>
              <input
                type="text"
                id="firstName"
                name="firstName"
                required
                value={myProfileUpdate.firstName}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div>
            <div className='reg-text'>
              <label htmlFor="lastName">Last Name</label>
            </div>
            <div>
              <input
                type="text"
                id="lastName"
                name="lastName"
                required
                value={myProfileUpdate.lastName}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div>
            <div className='reg-text-email'>
              <label htmlFor="email">Phone</label>
            </div>
            <div>
              <input
                type="phone"
                id="phone"
                name="phone"
                required
                value={myProfileUpdate.phone}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div>
            <div className='reg-text-email'>
              <label htmlFor="birthday">Birthdate</label>
            </div>
            <div>
              <input
                type="date"
                id="birthday"
                name="birthday"
                required
                value={myProfileUpdate.birthday}
                onChange={handleInputChange}
              />
            </div>
          </div>
          {/* <div>
            <div className='reg-text-referral'>
              <label htmlFor="referral">Referral Code</label>
            </div>
            <div>
              <input
                type="text"
                id="referral"
                name="referral"
                value={myProfileUpdate.referral}
                onChange={handleInputChange}
              />
            </div>
          </div> */}

          <div>
            <button type="submit"> Register</button>
          </div>
        </form>
      </div>
     
    </div>
    <Footer />
    </>
  );
}

export default RegistrationForm;
